import { formatDateShortWithMonthName, FUSO_BRASILIA } from '@/shared/formatters';

const MS_IN_DAY = 1000 * 60 * 60 * 24;

export const calcularDiasRestantes = (dataExpiracaoISO: string): number => {
  const expiracao = new Date(dataExpiracaoISO).getTime();
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.ceil((expiracao - hoje.getTime()) / MS_IN_DAY);
};

export const calcularDiasPeriodo = (dataInicioISO: string, dataFimISO: string): number => {
  const inicio = new Date(dataInicioISO).getTime();
  const fim = new Date(dataFimISO).getTime();
  return Math.max(0, Math.round((fim - inicio) / MS_IN_DAY));
};

export const isProximoVencimento = (
  dataExpiracaoISO: string,
  alertaDias: number | null,
): boolean => {
  const limite = alertaDias ?? 7;
  const diasRestantes = calcularDiasRestantes(dataExpiracaoISO);
  return diasRestantes >= 0 && diasRestantes <= limite;
};

export const isExpiradoHaMaisDe = (dataExpiracaoISO: string, dias: number): boolean => {
  return calcularDiasRestantes(dataExpiracaoISO) <= -dias;
};

const parseAsLocalDate = (dataISO: string): Date => {
  if (dataISO.includes('T')) return new Date(dataISO);
  return new Date(`${dataISO}T00:00:00`);
};

export const isDataFutura = (dataISO: string): boolean => {
  const data = parseAsLocalDate(dataISO);
  data.setHours(0, 0, 0, 0);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return data.getTime() > hoje.getTime();
};

export const isDataHojeOuFutura = (dataISO: string): boolean => {
  const data = parseAsLocalDate(dataISO);
  data.setHours(0, 0, 0, 0);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return data.getTime() >= hoje.getTime();
};

export const formatarDataCurta = (dataISO: string): string =>
  formatDateShortWithMonthName(dataISO) || '—';

const DATA_HORA_CURTA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO_BRASILIA,
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatarDataHora = (dataISO: string): string => {
  if (!dataISO) return '—';
  const data = new Date(dataISO);
  if (Number.isNaN(data.getTime())) return '—';
  return DATA_HORA_CURTA.format(data);
};

export const formatarDiasRestantes = (dias: number): string => {
  if (dias > 1) return `${dias} dias restantes`;
  if (dias === 1) return '1 dia restante';
  if (dias === 0) return 'Vence hoje';
  if (dias === -1) return 'Expirado há 1 dia';
  return `Expirado há ${Math.abs(dias)} dias`;
};

export const dataAtualISO = (): string => {
  const hoje = new Date();
  return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(
    hoje.getDate(),
  ).padStart(2, '0')}`;
};

export const toLocalYMD = (dataISO: string): string => {
  if (!dataISO) return '';
  const data = new Date(dataISO);
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-${String(
    data.getDate(),
  ).padStart(2, '0')}`;
};
